import React, { useState, useEffect, useRef } from 'react'
import { useSelector, useDispatch } from 'react-redux'
import { useQueryClient } from '@tanstack/react-query'
import NoImage from '../../Assets/Images/Logos/no-image.png'
import Modal from 'react-bootstrap/Modal'
import info from '../../Assets/Images/Product/info-circle.svg'
import MiniLoading from '../MiniLoading'
import 'react-responsive-carousel/lib/styles/carousel.min.css'
import { Carousel } from 'react-responsive-carousel'
import Table from 'react-bootstrap/Table'
import 'react-tabs/style/react-tabs.css'
import No from '../../Assets/Images/Login/no.svg'
import { Clipboard, ShareFill } from 'react-bootstrap-icons'
import ProductsCarrousel from '../ProductsCarrousel'
import './productDetail.css'
import cmfLogo from '../../Assets/Images/Product/logo-cmf.svg'
import calculator from '../../Assets/Images/Product/calculator.svg'
import pdfIcon from '../../Assets/Images/Product/pdf.svg'
import _ from 'lodash'
import { Col, Row } from 'react-bootstrap'
import { CopyToClipboard } from 'react-copy-to-clipboard'
import { FormatMoney } from '../../Utils/functions'
import LightTooltip from '../LightTooltip'
import GenericModal from 'Components/GenericModal'
import { t } from 'i18next'
import { getPriceInventoryGeneral } from 'redux/actions/priceProductsAction'
import {
  getCmfPriceAction,
  fetchProductDetaill,
  getRefererCreateAction,
  getSpecificCampaignAction,
  getcmfCampaignsAction,
} from 'redux/actions/productActions'
import { useDebounce } from 'Hooks/useDebounce'
import { VAPermissions, noWarranty } from 'Utils/constants'
import useValidatePermission from 'Hooks/useValidatePermission'
import CostMarginVisibility from 'Components/CostMarginVisibility/CostMarginVisibility'
import aa from 'search-insights'
import { useProductSearchContext } from 'state/context/ProductSearchContext'
import InventoryModal from 'Components/InventoryModal'
import ServiceCard from 'Components/ServiceCard/ServiceCard'
import { validateRepeatedProduct } from 'Utils/functions'
import InputMask from 'react-input-mask'
import { useProductQuantity } from 'Components/CartProduct/hooks/useProductQuantity'
import drill from '../../Views/CustomerDisplay/assets/drillBlue.svg'
import rating from '../../Views/CustomerDisplay/assets/ratingBlue.svg'
import { useTintsController } from 'Hooks/useTintsController'
import { validateHasCalculator } from 'redux/actions/materialsCalculatorActions'
import TintDropdown from 'Hooks/useTintsController/TintDropdown'
import ExtendedWarrantyCard from 'Components/ExtendedWarrantyCard/ExtendedWarrantyCard'
import useHandleWarranty from 'Hooks/Cart/useHandleWarranty'
import { useWarrantyTypes } from 'Hooks/Products/useWarrantyTypes'
import NetworkErrorAlert from '../NetworkErrorAlert'
import { QUERY_KEYS } from 'Utils/queryKeys'

aa('init', {
  appId: 'ZCZRBTYD8I',
  apiKey: '6c9235a951666253b5b003e1cf34d9ce',
})

const CMF_QUOTAS = 36

function ProductDetail({
  id,
  price,
  openWithInventario,
  handleClose,
  producto_final: productoFinal,
  productsRef,
  cost,
  setShowMaterialsCalculatorPDP,
  setProductDetail,
  isCustomerDisplay,
  onRelatedProductDetailChange,
}) {
  const debounce = useDebounce()
  const queryClient = useQueryClient()
  const [product, setProduct] = useState(null)
  const [similarProducts, setSimilarProducts] = useState([])
  const [recommendedProducts, setRecommendedProducts] = useState([])
  const [company] = useState(window.localStorage.getItem('company'))
  const [openCMF, setOpenCMF] = useState(false)
  const [showMessage, setShowMessage] = useState(false)
  const [inactiveMessage, setInactiveMessage] = useState(false)
  const [cmfCode, setCmfCode] = useState(false)
  const [precioCmf, setPrecioCmf] = useState({})
  const dispatch = useDispatch()
  const { calculateAlgoliaHitPosition } = useProductSearchContext()

  const [, setStateDetalle] = useState(false)

  const [exCodes, setExCodes] = useState([])

  const [showAlertDontAddProduct, setShowAlertDontAddProduct] = useState(false)
  const [showNetworkErrorAlert, setShowNetworkErrorAlert] = useState(false)
  const [apiErrorMessage, setApiErrorMessage] = useState(null)

  const [caracteristicasUnidadMedida, setCaracteristicasUnidadMedida] =
    useState([])
  const [caracteristicasGeneral, setCaracteristicasGeneral] = useState([])
  const [warrantyAttributes, setWarrantyAttributes] = useState([])

  const [cmfCopiado, setCmfCopiado] = useState(false)
  const [showModalImage, setShowModalImage] = useState({
    active: false,
    image: null,
  })

  const [meters, setMeters] = useState('')
  const [boxes, setBoxes] = useState('')

  const cart = useSelector(state => state.cart.cart)
  const [user] = useState(useSelector(state => state.login.user))
  const companyId = useSelector(state => state.company.CompanyId)
  const companyCode = useSelector(state => state.company.CompanyCode)
  const warehouse = useSelector(state => state.company.WarehouseId)
  const algoliaIndex = useSelector(
    state => state?.login?.checkCompany?.[0].InitialCatalog
  )
  const customerId = useSelector(
    state => state.cotizacion?.QuoteHeader?.CustomerId
  )

  const ShortDescriptionRef = useRef(null)

  const seeMargenProd = useValidatePermission(VAPermissions.seeMargenProd)
  const seeCostProd = useValidatePermission(VAPermissions.seeCostProd)

  const [isOpenInventory, setIsOpenInventory] = useState(openWithInventario)
  const [selectedProductId, setSelectedProductId] = useState(null)

  // WARRANTY
  const { addWarranty } = useHandleWarranty()
  const { data: warrantyOptions = [] } = useWarrantyTypes()
  const [selectedWarranty, setSelectedWarranty] = useState(noWarranty)

  const {
    quantity,
    inputMask,
    handleBlur,
    handleAddProduct,
    handleRemoveProduct,
    handleProdQuantity,
  } = useProductQuantity({ ...product, Quantity: 1 }, false)

  const {
    tints,
    selectedTints,
    isLoadingTints,
    isErrorTints,
    toggleTint,
    isSelected,
    shouldShow,
    formattedSelectedTints,
  } = useTintsController({
    sku: product?.Sku,
    hasVariant: product?.HasVariant,
  })

  const buildCmfLink = async referral => {
    const payload = {
      CampaignReferralId: referral.CampaignReferralId,
      ReferrerName: user.CustomerInfo.FullName,
      IdentityNumber: user.CustomerInfo.IDNumber,
      ExternalCode: user.CustomerInfo.CustomerId,
    }
    const response = await dispatch(getRefererCreateAction(payload))
    if (response && response.data) {
      setCmfCode(referral.ReferralLink + response.data.response)
    } else {
      console.error('Error:', response.toString())
      throw new Error(response.toString())
    }
  }

  const getSpecificCampaign = async referral => {
    const response = await dispatch(getSpecificCampaignAction(referral))
    if (response && response.data) {
      buildCmfLink(response.data?.response[0])
    } else {
      console.error('Error:', response.toString())
      throw new Error(response.toString())
    }
  }

  const fetchCampaigns = async () => {
    const response = await dispatch(
      getcmfCampaignsAction(user.CustomerInfo.CustomerId)
    )
    if (response && response.data) {
      const campaignCmf = response.data.response.filter(
        campaign => campaign.CampaignName === 'CMF'
      )

      if (campaignCmf.length > 0) {
        getSpecificCampaign(campaignCmf[0].CampaignReferralId)
      }
    } else {
      console.error('Error:', response.toString())
      throw new Error(response.toString())
    }
  }

  const fetchHasCalculator = async product => {
    const payload = {
      DepartmentId: product.DepartmentId,
      CompanyId: companyId,
      CategoryId: product.CategoryId,
      SubCategoryId: product.SubCategoryId,
      ProductIds: [product.ProductId],
    }
    const response = await dispatch(validateHasCalculator({ payload }))
    if (response) {
      setProduct({
        ...product,
        HasCalculatorProduct: response.ProductIds?.[0].HasCalculator,
      })
    } else {
      console.error('Error:', response.toString())
      throw new Error(response.toString())
    }
  }

  const fetchDataCMF = async () => {
    const payload = {
      loanTerm: CMF_QUOTAS,
      initDate: '2022-05-04T21:52:53.030Z',
      disbursementDate: '2022-05-04T21:52:53.030Z',
      cashValueProduct: productoFinal?.FinalPrice,
      rateDownPayment: 33,
      valueDownPayment: 100,
    }
    const response = await dispatch(getCmfPriceAction(payload))
    if (response && response.data?.data) {
      setPrecioCmf(response.data?.data)
    } else {
      console.error('Error:', response.toString())
      throw new Error(response.toString())
    }
  }

  const getPrices = async PriceInventoryPayload => {
    try {
      const response = await dispatch(
        getPriceInventoryGeneral(PriceInventoryPayload)
      )
      return response?.data?.Data
    } catch (error) {
      console.error(error)
    }
  }

  const fetchPriceInventory = async (hits, CustomerId) => {
    const PriceInventoryData = {
      CompanyId: companyId,
      CompanyCode: companyCode,
      WarehouseId: warehouse,
      ProductIds: [],
      CustomerId: CustomerId || null,
      UoMId: null,
    }
    if (hits && hits.length > 0) {
      hits.map(item => PriceInventoryData.ProductIds.push(item.productId))
    }
    const priceData = await getPrices(PriceInventoryData)
    let productArrayWithPrice = []
    if (hits && hits.length > 0) {
      productArrayWithPrice = [...hits]
    }

    try {
      // eslint-disable-next-line array-callback-return
      productArrayWithPrice.map(item => {
        item.BasePrice = priceData?.find(
          product => product.ProductId === item.productId
        )?.BasePrice
        item.TaxCategoryValue = priceData?.find(
          product => product.ProductId === item.productId
        )?.TaxCategoryValue
        item.Cost = priceData?.find(
          product => product.ProductId === item.productId
        )?.Cost
        item.ProductId = priceData?.find(
          product => product.ProductId === item.productId
        )?.ProductId
        item.FinalPrice = priceData?.find(
          product => product.ProductId === item.productId
        )?.FinalPrice
        item.TotalQty = priceData?.find(
          product => product.ProductId === item.productId
        )?.TotalQty
        item.WarehouseQty = priceData?.find(
          product => product.ProductId === item.productId
        )?.WarehouseQty
        item.PriceListId = priceData?.find(
          product => product.ProductId === item.productId
        )?.PriceListId
      })
      return productArrayWithPrice
    } catch (error) {
      return console.error('Error al filtrar precios', error)
    }
  }

  const fetchProduct = async () => {
    const productData = await queryClient.fetchQuery({
      queryKey: [QUERY_KEYS.PRODUCT_DETAIL, id, companyId, warehouse],
      queryFn: async () => {
        const res = await fetchProductDetaill({
          CompanyId: companyId,
          WarehouseId: warehouse,
          ProductId: id,
          GlobalExecution: true,
        })()
        return res?.data?.[0] ?? null
      },
      staleTime: 1000 * 60 * 30,
      cacheTime: 1000 * 60 * 60 * 2,
    })
    if (productData) {
      let imagesFilter
      if (productData?.Images !== null) {
        imagesFilter = productData?.Images?.filter(
          item =>
            item.MediaResourceName === 'Product Image' ||
            item.MediaResourceName === 'Web'
        )
      }
      const dataProduct = { ...productData, Images: imagesFilter }
      setProduct(dataProduct)
      setProductDetail?.(dataProduct)
      fetchHasCalculator(dataProduct)
      if (productData?.PIMAttributes?.similarProducts?.length > 0) {
        fetchPriceInventory(productData.PIMAttributes.similarProducts)
          .then(res =>
            setSimilarProducts(
              res.map(item => ({ ...item, Sku: item.systemCode }))
            )
          )
          .catch(err => {
            throw err
          })
      }
      if (productData?.PIMAttributes?.relatedProducts?.length > 0) {
        fetchPriceInventory(productData.PIMAttributes.relatedProducts)
          .then(res =>
            setRecommendedProducts(
              res.map(item => ({ ...item, Sku: item.systemCode }))
            )
          )
          .catch(err => {
            throw err
          })
      }
    } else {
      throw new Error('Error fetching product detail')
    }
  }

  const getSecureFirstItemOfArray = async arrayData => {
    try {
      return arrayData[0] || {}
    } catch (error) {
      return {}
    }
  }

  const getBarCode = barcodes => {
    let dataReturn = null
    if (barcodes && barcodes.length) {
      let barcodeObject = barcodes.find(obj => obj.DefaultBarcode)
      if (!_.isEmpty(barcodeObject) && !barcodeObject.Barcode)
        barcodeObject = barcodes[0]
      dataReturn = !_.isEmpty(barcodeObject) ? barcodeObject.Barcode : null
    }
    return dataReturn
  }

  const loopOverData = (keys, attributes) => {
    // eslint-disable-next-line no-async-promise-executor
    return new Promise(async (resolve, reject) => {
      try {
        const array = [].constructor
        const object = {}.constructor
        const boolean = true.constructor
        let data = []
        for (let i = 0; i < keys.length; i++) {
          const key = keys[i]
          const value = attributes[key]
          if (value) {
            if (value.constructor === object) {
              const objectData = await loopOverData(
                Object.keys(value),
                value
              ).catch(() => [{}])
              data = [...data, ...objectData]
            } else if (value.constructor === array) {
              const names = value.join(', ')
              data = [
                ...data,
                {
                  title: key.charAt(0).toUpperCase() + key.slice(1),
                  value: names,
                },
              ]
            } else if (value.constructor === boolean) {
              data = [
                ...data,
                {
                  title: key.charAt(0).toUpperCase() + key.slice(1),
                  value: value ? 'Yes' : 'No',
                },
              ]
            } else {
              data = [
                ...data,
                {
                  title: key.charAt(0).toUpperCase() + key.slice(1),
                  value,
                },
              ]
            }
          }
        }
        resolve(data)
      } catch (error) {
        reject(error)
      }
    })
  }

  const getPInfoData = async productDetails => {
    const measurements = await getSecureFirstItemOfArray(
      productDetails.Measurements
    )
    const attributes = productDetails?.PIMAttributes?.attributes || null

    const measurementsKeys = Object.keys(measurements).filter(
      key =>
        key.endsWith('UomName') ||
        key.endsWith('Length') ||
        key.endsWith('Height') ||
        key.endsWith('Width') ||
        key.endsWith('Weight')
    )
    const measurmentsAttributes = []
    measurementsKeys.forEach(foundKey => {
      if (foundKey === 'UomName') {
        measurmentsAttributes.push({
          title: `${foundKey}`,
          value: `${measurements[foundKey]}`,
        })
      } else {
        measurmentsAttributes.push({
          title: `${foundKey}`,
          value: `${measurements[foundKey]} ${measurements[`${foundKey}Abbr`]}`,
        })
      }
    })
    let _attributes = [
      {
        title: 'Brand',
        value: productDetails.BrandName,
      },
      {
        title: 'PartNumber',
        value: productDetails.ManufacturerPartNumber,
      },
      {
        title: 'Barcode',
        value: getBarCode(productDetails.BarCodes),
      },
    ]
    if (attributes) {
      const firstLevel = Object.keys(attributes)
      const filtered = firstLevel?.filter(
        key =>
          !key.includes('cc') &&
          !key.includes('core') &&
          !key.includes('groupWarranty')
      )
      const otherPimAttributes = await loopOverData(filtered, attributes).catch(
        () => []
      )
      _attributes = [..._attributes, ...otherPimAttributes]
      const warrantyData = attributes.groupWarranty || []
      const warrantyAttributes = warrantyData.map(key => ({
        title: key.etiqueta,
        value: key.valor,
      }))
      setWarrantyAttributes(warrantyAttributes)
    }
    setCaracteristicasGeneral(_attributes)
    setCaracteristicasUnidadMedida(measurmentsAttributes)
    setStateDetalle(true)
  }

  const removeProduct = () => {
    if (quantity > 1) {
      handleRemoveProduct(quantity - 1)
    }
  }

  useEffect(() => {
    fetchProduct()
    fetchCampaigns()
    if (productoFinal?.BasePrice >= 25) {
      fetchDataCMF()
    }
  }, [])

  useEffect(() => {
    setSelectedProductId(id)
  }, [id])

  useEffect(() => {
    if (ShortDescriptionRef.current && product?.ShortDescription) {
      ShortDescriptionRef.current.innerHTML = product?.ShortDescription
    }
  }, [ShortDescriptionRef.current, product])

  useEffect(() => {
    if (product) {
      getPInfoData(product)
    }
  }, [product])

  const handleCmf = () => {
    setOpenCMF(true)
  }

  const handleCalc = e => {
    e.preventDefault()
    if (meters.length >= 1) {
      setBoxes(true)
    }
  }

  const handleMeters = e => {
    setMeters(e.target.value)
  }

  const handleAdd = async () => {
    // Limpiar cualquier aviso de error previo al iniciar un nuevo intento.
    setShowNetworkErrorAlert(false)

    if (!product?.IsActive) {
      setInactiveMessage(true)
      setTimeout(() => setInactiveMessage(false), 3000)
      return
    }

    const productPayload = {
      ...productoFinal,
      WarrantyYears: selectedWarranty?.WarrantyYears,
      hasExtendedWarranty:
        product?.PIMAttributes?.attributes?.coreDetail?.hasExtendedWarranty,
      relatedServices: product?.PIMAttributes?.relatedServices,
      installable: product?.PIMAttributes?.attributes?.coreDetail?.installable,
      hasDiscount: productoFinal.BasePrice > productoFinal.FinalPrice,
      qty: quantity,
      Quantity: quantity,
      ColorVariants: formattedSelectedTints,
      ProductTypeId: product?.ProductTypeId ?? productoFinal?.ProductTypeId,
    }

    const isOffline = !navigator.onLine
    const alreadyInCart = cart.some(
      item => item.ProductId === productPayload.ProductId
    )

    // Sin conexión y el producto aún no está en el carrito:
    // no es posible obtener el precio desde la API, se bloquea el agregado.
    if (isOffline && !alreadyInCart) {
      setShowNetworkErrorAlert(true)
      setTimeout(() => setShowNetworkErrorAlert(false), 4000)
      return
    }

    try {
      const added = await validateRepeatedProduct(
        productPayload,
        cart,
        dispatch,
        customerId,
        addWarranty,
        selectedWarranty?.WarrantyYears ? selectedWarranty : null
      )

      if (!added) {
        setShowAlertDontAddProduct(true)
        setTimeout(() => {
          setShowAlertDontAddProduct(false)
          handleClose()
        }, 2000)
      } else {
        setSelectedWarranty(noWarranty)
        handleClose()
      }
    } catch (_err) {
      const isNetworkError = !navigator.onLine || !_err?.response
      if (isNetworkError) {
        setShowNetworkErrorAlert(true)
        setTimeout(() => setShowNetworkErrorAlert(false), 4000)
      } else {
        const apiMessage =
          _err?.response?.data?.Status?.Message ||
          _err?.response?.data?.message ||
          ''
        setApiErrorMessage(apiMessage)
        setTimeout(() => setApiErrorMessage(null), 4000)
      }
    }
  }

  useEffect(() => {
    if (product?.ExternalCodes?.length > 0) {
      const codes = product.ExternalCodes.map(externalCode => {
        if (externalCode.ExternalSystem === 'SCC') {
          externalCode.ExternalSystem = 'SALESFORCE'
        }
        return externalCode
      })

      const filterExternalCodes = codes.filter(
        externalCode =>
          externalCode.ExternalSystem === 'NAF_BASE' ||
          externalCode.ExternalSystem === 'NAF_NOVEY' ||
          externalCode.ExternalSystem === 'IVEND' ||
          externalCode.ExternalSystem === 'SALESFORCE' ||
          externalCode.ExternalSystem === 'PROVIVIENDA'
      )

      setExCodes(filterExternalCodes)
    }
  }, [product])

  const costProduct = productoFinal.Cost
  const avgCost = productoFinal.AvgCost

  const handleConversion = hit => {
    const pageData = calculateAlgoliaHitPosition.find(p =>
      p.hits.some(h => h.objectID === hit.objectID)
    )

    const queryID = pageData?.queryID || ''

    aa('convertedObjectIDsAfterSearch', {
      eventName: 'ADDED_TO_QUOTE',
      index: algoliaIndex,
      objectIDs: [hit.objectID],
      queryID,
      userToken: aa('getUserToken'),
    })
  }

  const handleOpenInventory = productId => {
    setSelectedProductId(productId)
    setIsOpenInventory(true)
  }

  const handleCloseInventory = () => {
    const delay = openWithInventario ? 500 : 0
    openWithInventario && handleClose()
    debounce(() => {
      setSelectedProductId(null)
      setIsOpenInventory(false)
    }, delay)
  }
  const [zoom, setZoom] = useState(1)

  const handleZoomIn = () => setZoom(prev => Math.min(prev + 0.2, 3)) // máximo 3x
  const handleZoomOut = () => setZoom(prev => Math.max(prev - 0.2, 0.5)) // mínimo 0.5x
  const handleReset = () => setZoom(1)

  const CarrouselImages = () => {
    return (
      <Col xs={12} sm={12} md={12} lg={6} xl={5} className="text-center">
        <Carousel showStatus={false} showThumbs={false} showArrows={false}>
          {product.Images &&
            product.Images.map(image => {
              return (
                <div
                  style={{
                    width: '100%',
                    height: 'auto',
                    marginBottom: '20px',
                  }}
                  onClick={() => {
                    setShowModalImage({ active: true, image: image.URL })
                  }}
                  key={image?.ImageId}>
                  <img
                    src={image.URL}
                    alt={image.ImageId}
                    style={{
                      width: '100%',
                      height: 'auto',
                    }}
                    className="img-fluid"
                  />
                </div>
              )
            })}
        </Carousel>
        {!product.Images && <img src={NoImage} />}
      </Col>
    )
  }

  return (
    <>
      {product ? (
        <div
          className="container-card-product-detail"
          data-testid="container-product-detail"
          style={{ paddingTop: isCustomerDisplay ? 20 : 0 }}>
          <Row>
            <Col xs={12} sm={12} md={12} lg={12} xl={12}>
              <div className="close-button product-detail-container-padding">
                <img
                  src={No}
                  alt="close"
                  onClick={() => {
                    handleClose()
                    if (!isCustomerDisplay) {
                      setShowMaterialsCalculatorPDP?.(false)
                    }
                  }}
                  data-testid="btn-close-product-detail"
                />
              </div>
            </Col>
          </Row>

          <Row>
            {<CarrouselImages />}
            <Col xs={12} sm={12} md={12} lg={6} xl={7}>
              <div
                className="general-product-data product-detail-container-padding"
                data-testid="container-product-general-data">
                <h2 className="product-title" data-testid="title-product-name">
                  {product.ProductName}
                </h2>
                <h2 className="product-brand" data-testid="text-product-brand">
                  {product.BrandName || 'GÉNERICO'}
                </h2>
                <p className="product-sku" data-testid="text-product-sku">
                  {product.Sku}
                </p>
                <ul className="product-tags" data-testid="list-product-tags">
                  {product.Tags &&
                    product.Tags.split(',').map((tag, i) => {
                      return (
                        <li
                          key={i}
                          className="product-tag"
                          data-testid={`item-product-tag-${i}`}>
                          {tag}.
                        </li>
                      )
                    })}
                </ul>
                {product?.ShortDescription && (
                  <div
                    ref={ShortDescriptionRef}
                    className="product-short-description"
                    data-testid="text-product-short-description"
                  />
                )}
                {product?.PIMAttributes?.attributes?.corePurchase
                  ?.productFactor > 1 ? (
                  <>
                    <p
                      className="product-price"
                      data-testid="text-product-price-square-meter">
                      {price === undefined
                        ? 'Sin precio'
                        : '$' +
                          FormatMoney(
                            price /
                              product?.PIMAttributes?.attributes?.corePurchase
                                ?.productFactor
                          )}
                      /m<sup>2</sup>
                    </p>
                    <p
                      className="especial-price-caja"
                      data-testid="text-product-price-box">
                      {price === undefined
                        ? 'Sin precio'
                        : '$' + price?.toFixed(2)}
                      /caja
                    </p>
                  </>
                ) : (
                  <p className="product-price" data-testid="text-product-price">
                    {price === undefined
                      ? 'Sin precio'
                      : '$' + FormatMoney(price)}
                  </p>
                )}
                <p
                  className="product-card-discount"
                  data-testid="text-product-regular-price">
                  {productoFinal?.BasePrice === undefined && price === undefined
                    ? ''
                    : productoFinal?.BasePrice === price
                    ? ''
                    : 'Precio regular: $' +
                      productoFinal?.BasePrice?.toFixed(2)}
                </p>
                {isCustomerDisplay && (
                  <>
                    {product.PIMAttributes?.attributes?.coreDetail
                      ?.hasExtendedWarranty && (
                      <div
                        className="container-services-warranty-availibility"
                        data-testid="container-product-extended-warranty">
                        <img src={rating} />
                        <p data-testid="text-product-extended-warranty">
                          Disponibilidad de Garantía extendida
                        </p>
                      </div>
                    )}

                    {product.PIMAttributes?.attributes?.coreDetail
                      ?.installable &&
                      product.PIMAttributes?.relatedServices && (
                        <div
                          className="container-services-warranty-availibility"
                          data-testid="container-product-installation-service">
                          <img src={drill} />
                          <p data-testid="text-product-installation-service">
                            Disponibilidad de Servicio de instalación
                          </p>
                        </div>
                      )}
                  </>
                )}
                <br />
                {!isCustomerDisplay && productoFinal?.BasePrice >= 25 && (
                  <div
                    className="cmf-content"
                    data-testid="container-product-cmf">
                    <img src={cmfLogo} alt="logo_cmf" />
                    <p>
                      ${CMF_QUOTAS} cuotas de ${precioCmf?.monthlyQuota} c/u.{' '}
                      <span>
                        <LightTooltip
                          title="*Valor cuota referencial calculada con 33% de interés anual."
                          placement="left">
                          <img src={info} alt="info-circle" />
                        </LightTooltip>{' '}
                      </span>
                      {cmfCode && (
                        <p>
                          Si el cliente aún no tiene la tarjeta{' '}
                          <button
                            onClick={handleCmf}
                            data-testid="btn-open-cmf-link">
                            ingresa aquí
                          </button>
                        </p>
                      )}
                    </p>
                  </div>
                )}

                {!isCustomerDisplay && (
                  <>
                    <div
                      className="product-counter"
                      data-testid="container-product-counter">
                      <button
                        className="product-btn-counter minus"
                        onClick={removeProduct}
                        data-testid="btn-decrease-product-quantity">
                        -
                      </button>
                      <InputMask
                        maskChar=""
                        mask={inputMask}
                        value={quantity}
                        inputMode="decimal"
                        className="product-btn-counter"
                        onBlur={handleBlur}
                        onChange={handleProdQuantity}
                        data-testid="input-product-quantity"
                      />
                      <button
                        className="product-btn-counter plus"
                        onClick={handleAddProduct}
                        data-testid="btn-increase-product-quantity">
                        +
                      </button>
                    </div>
                    <TintDropdown
                      tints={tints}
                      isLoading={isLoadingTints}
                      isError={isErrorTints}
                      onSelect={toggleTint}
                      isSelected={isSelected}
                      shouldShow={shouldShow}
                      selectedTints={selectedTints}
                    />
                    <div
                      className="product-detail-buttons"
                      data-testid="container-product-detail-buttons">
                      <button
                        className="product-detail-button-agregar"
                        onClick={event => {
                          event.stopPropagation()
                          handleConversion(productoFinal)

                          if (price) {
                            handleAdd()
                          } else {
                            setShowMessage(true)
                            setTimeout(() => {
                              setShowMessage(false)
                            }, 3000)
                          }
                        }}
                        data-testid="btn-add-product">
                        Agregar
                      </button>
                      <button
                        className="product-detail-button-inventario"
                        onClick={() => {
                          handleOpenInventory(id)
                        }}
                        data-testid="btn-open-product-inventory">
                        Inventario
                      </button>
                    </div>
                  </>
                )}

                {(seeMargenProd || seeCostProd) && !isCustomerDisplay ? (
                  <CostMarginVisibility
                    seeMargenProd={seeMargenProd}
                    seeCostProd={seeCostProd}
                    cost={costProduct}
                    avgCost={avgCost}
                    price={price}
                    isMargin
                    isCost
                    secondaryColor
                  />
                ) : null}
                <p
                  className="product-unidades"
                  data-testid="text-product-available-units">
                  {product.TotalQty} Unidades disponibles en {company}
                </p>

                {!isCustomerDisplay &&
                  product?.PIMAttributes?.attributes?.coreDetail?.installable &&
                  product?.PIMAttributes?.relatedServices?.[0]?.productId && (
                    <ServiceCard
                      services={product?.PIMAttributes?.relatedServices}
                    />
                  )}
                {!isCustomerDisplay &&
                  product?.PIMAttributes?.attributes?.coreDetail
                    ?.hasExtendedWarranty && (
                    <ExtendedWarrantyCard
                      price={
                        productoFinal.FinalPrice ?? productoFinal.BasePrice
                      }
                      product={product}
                      warrantyOptions={warrantyOptions}
                      selectedWarranty={selectedWarranty}
                      groupName={`warranty-${id}`}
                      onWarrantySelectChange={setSelectedWarranty}
                    />
                  )}
                {product?.PIMAttributes?.attributes?.corePurchase
                  ?.productFactor > 1 &&
                  !product.HasCalculatorProduct && (
                    <div
                      className="calculadora-de-piso"
                      data-testid="container-floor-calculator">
                      <div
                        className="calculadora-de-piso-header"
                        data-testid="container-floor-calculator-header">
                        <img src={calculator} alt="calculator-logo" />
                        <h2 data-testid="title-floor-calculator">
                          Calcula cuántas cajas necesitas para tu proyecto
                        </h2>
                      </div>
                      <div
                        className="calculadora-de-piso-body"
                        data-testid="container-floor-calculator-body">
                        <p
                          className="instrucciones-calc"
                          data-testid="text-floor-calculator-instructions">
                          Ingresa los m<sup>2</sup> que necesitas cubrir. Para
                          1m
                          <sup>2</sup> necesitas 1 caja
                        </p>
                        <form
                          onSubmit={handleCalc}
                          data-testid="container-floor-calculator-form">
                          <input
                            type="text"
                            placeholder="¿Cuántos m² necesitas?"
                            onChange={handleMeters}
                            data-testid="input-floor-calculator-meters"
                          />
                          <button
                            type="submit"
                            data-testid="btn-calculate-floor-boxes">
                            Calcular
                          </button>
                        </form>
                        {boxes && (
                          <div
                            className="calculadora-de-piso-resultado"
                            data-testid="container-floor-calculator-result">
                            <p data-testid="text-floor-calculator-result">
                              Necesitas{' '}
                              {Math.ceil(
                                parseFloat(meters) /
                                  product?.PIMAttributes?.attributes
                                    ?.corePurchase?.productFactor
                              )}{' '}
                              cajas para cubrir {meters} m<sup>2</sup>
                            </p>
                          </div>
                        )}
                      </div>
                    </div>
                  )}
                <div>
                  {showMessage && (
                    <p
                      className="message-alert"
                      data-testid="text-product-without-price-alert">
                      No se puede agregar, no cuenta con precio
                    </p>
                  )}
                  {inactiveMessage && (
                    <p
                      className="message-alert"
                      data-testid="text-product-inactive-alert">
                      {t('INACTIVE_PRODUCT_MESSAGE_T')}
                    </p>
                  )}
                </div>
              </div>
            </Col>
          </Row>
          {!isCustomerDisplay && recommendedProducts?.length > 0 && (
            <ProductsCarrousel
              productsRef={productsRef}
              data={recommendedProducts}
              title={'Productos recomendados'}
              parentProduct={product}
              onProductDetailChange={onRelatedProductDetailChange}
            />
          )}
          {!isCustomerDisplay && (
            <div
              className="product-detail-accordion product-detail-container-padding"
              data-testid="container-product-detail-accordion">
              <div
                className="detalles-accordion-container"
                data-testid="container-product-info-section">
                <div
                  // eslint-disable-next-line react/no-unknown-property
                  sx={{
                    boxShadow: 'none',
                    border: '1px solid #DFDFDF',
                    padding: '10px 23px',
                  }}>
                  <div>
                    <h2
                      className="product-detail-title"
                      style={{ color: '#003082', marginBottom: '30px' }}
                      data-testid="title-product-information">
                      Información del producto
                    </h2>
                  </div>
                  <div>
                    {product?.FullDescription && (
                      <>
                        <h3
                          style={{ marginBottom: '12px' }}
                          data-testid="title-product-details">
                          Detalles
                        </h3>
                        <div
                          className="product-full-description"
                          data-testid="text-product-full-description"
                          dangerouslySetInnerHTML={{
                            __html: product.FullDescription,
                          }}
                        />
                      </>
                    )}
                    <div style={{ marginTop: '36px' }}>
                      <h3
                        style={{ marginBottom: '12px' }}
                        data-testid="title-product-characteristics">
                        Características
                      </h3>

                      {caracteristicasGeneral.length > 0 && (
                        <div>
                          <Table
                            striped
                            bordered
                            hover
                            data-testid="table-product-general-characteristics">
                            <thead>
                              <tr>
                                <th className="general-table-header codes-external">
                                  General
                                </th>
                                <th></th>
                              </tr>
                            </thead>
                            <tbody>
                              {caracteristicasGeneral.map(
                                (caracteristica, index) => {
                                  return caracteristica.value ? (
                                    <tr
                                      className="product-tag"
                                      key={index}
                                      data-testid={`item-product-general-characteristic-${index}`}>
                                      <td
                                        data-testid={`text-product-general-characteristic-title-${index}`}>
                                        {caracteristica.title}
                                      </td>
                                      <td
                                        data-testid={`text-product-general-characteristic-value-${index}`}
                                        style={{ whiteSpace: 'pre-line' }}>
                                        {caracteristica.value}
                                      </td>
                                    </tr>
                                  ) : null
                                }
                              )}
                            </tbody>
                          </Table>
                          <br />
                        </div>
                      )}

                      {warrantyAttributes.length > 0 && (
                        <div>
                          <Table
                            striped
                            bordered
                            hover
                            data-testid="table-product-general-characteristics">
                            <thead>
                              <tr>
                                <th className="general-table-header codes-external">
                                  Atributos de garant&iacute;a
                                </th>
                                <th></th>
                              </tr>
                            </thead>
                            <tbody>
                              {warrantyAttributes.map((attribute, index) => {
                                return attribute.value ? (
                                  <tr
                                    className="product-tag"
                                    key={index}
                                    data-testid={`item-product-general-characteristic-${index}`}>
                                    <td
                                      data-testid={`text-product-general-characteristic-title-${index}`}>
                                      {attribute.title}
                                    </td>
                                    <td
                                      data-testid={`text-product-general-characteristic-value-${index}`}
                                      style={{ whiteSpace: 'pre-line' }}>
                                      {attribute.value}
                                    </td>
                                  </tr>
                                ) : null
                              })}
                            </tbody>
                          </Table>
                          <br />
                        </div>
                      )}

                      {caracteristicasUnidadMedida.length > 0 && (
                        <Table
                          striped
                          bordered
                          hover
                          data-testid="table-product-measurements">
                          <thead>
                            <tr>
                              <th
                                style={{
                                  fontSize: '16px',
                                }}
                                className="general-table-header codes-external">
                                Medidas
                              </th>
                              <th></th>
                            </tr>
                          </thead>
                          <tbody>
                            {caracteristicasUnidadMedida.map(
                              (caracteristica, index) => {
                                return (
                                  <tr
                                    className="product-tag"
                                    key={index}
                                    data-testid={`item-product-measurement-${index}`}>
                                    <td
                                      data-testid={`text-product-measurement-title-${index}`}>
                                      {caracteristica.title}
                                    </td>
                                    <td
                                      data-testid={`text-product-measurement-value-${index}`}>
                                      {caracteristica.value}
                                    </td>
                                  </tr>
                                )
                              }
                            )}
                          </tbody>
                        </Table>
                      )}
                      <br />
                      <Table
                        striped
                        bordered
                        hover
                        data-testid="table-product-external-codes">
                        <thead>
                          <tr>
                            <th className="general-table-header codes-external">
                              Códigos Externos
                            </th>
                            <th></th>
                          </tr>
                        </thead>
                        <tbody>
                          {exCodes.length > 0 &&
                            exCodes.map((xcodes, index) => {
                              return xcodes.ExternalCode ? (
                                <tr
                                  className="product-tag"
                                  key={index}
                                  data-testid={`item-product-external-code-${index}`}>
                                  <td
                                    data-testid={`text-product-external-code-system-${index}`}>
                                    {xcodes.ExternalSystem}
                                  </td>
                                  <td
                                    data-testid={`text-product-external-code-value-${index}`}>
                                    {xcodes.ExternalCode}
                                  </td>
                                </tr>
                              ) : null
                            })}
                        </tbody>
                      </Table>
                    </div>
                  </div>
                </div>
              </div>

              {product?.Documents?.length > 0 && (
                <div
                  className="ficha-accordion-container"
                  data-testid="container-product-datasheet-section">
                  <div
                    // eslint-disable-next-line react/no-unknown-property
                    sx={{
                      boxShadow: 'none',
                      border: '1px solid #DFDFDF',
                      padding: '10px 23px',
                    }}>
                    <div>
                      <h2
                        className="product-detail-title"
                        style={{ color: '#003082', marginBottom: '30px' }}
                        data-testid="title-product-datasheet">
                        Ficha Técnica
                      </h2>
                    </div>
                    <div>
                      {product.Documents &&
                        product?.Documents.filter(
                          document =>
                            document.CompanyId === companyId ||
                            document.MediaResourceName === 'Datasheets'
                        ).map(document => {
                          return (
                            <div
                              key={document?.DocumentId}
                              className="ficha-tecnica-info"
                              data-testid={`item-product-document-${document?.DocumentId}`}>
                              <img src={pdfIcon} alt="pdfIcon" />
                              <a
                                href={document?.URL}
                                target="_blank"
                                rel="noreferrer"
                                data-testid={`btn-product-document-${document?.DocumentId}`}>
                                <p
                                  data-testid={`text-product-document-resource-${document?.DocumentId}`}>
                                  {document.MediaResourceName}
                                </p>
                                <p
                                  data-testid={`text-product-document-company-${document?.DocumentId}`}>
                                  {document.CompanyName}
                                </p>
                              </a>
                            </div>
                          )
                        })}
                    </div>
                  </div>
                </div>
              )}
            </div>
          )}

          {!isCustomerDisplay && similarProducts?.length > 0 && (
            <ProductsCarrousel
              productsRef={productsRef}
              data={similarProducts}
              title={'Productos similares'}
              parentProduct={product}
              onProductDetailChange={onRelatedProductDetailChange}
            />
          )}
        </div>
      ) : (
        <MiniLoading full={true} />
      )}
      <InventoryModal
        isOpen={isOpenInventory}
        onClose={handleCloseInventory}
        productId={selectedProductId}
      />
      <Modal
        show={openCMF}
        aria-labelledby="modal-modal-title"
        aria-describedby="modal-modal-description"
        centered>
        <div className="cmf-modal-box" data-testid="container-cmf-modal">
          <div className="top-cmf" data-testid="container-cmf-modal-top">
            <img src={cmfLogo} alt="logo_cmf" />
            <img
              src={No}
              onClick={() => {
                setOpenCMF(false)
                setCmfCopiado(false)
              }}
              alt="close"
              data-testid="btn-close-cmf-modal"
            />
          </div>
          <div className="cmf-clipboard" data-testid="container-cmf-clipboard">
            <p data-testid="text-cmf-code">{cmfCode}</p>
            <CopyToClipboard text={cmfCode} onCopy={() => setCmfCopiado(true)}>
              <Clipboard data-testid="btn-copy-cmf-code" />
            </CopyToClipboard>
            <ShareFill data-testid="btn-share-cmf-code" />
          </div>
          {cmfCopiado && (
            <div
              className="copiado-confirmation"
              data-testid="container-cmf-copied-confirmation">
              <p data-testid="text-cmf-copied-confirmation">Copiado</p>
            </div>
          )}
        </div>
      </Modal>
      {isCustomerDisplay && (
        <div
          className="container-modal-images"
          data-testid="container-product-image-modal">
          <Modal
            show={showModalImage.active}
            className="show-modal-images"
            centered
            size="xl"
            onHide={() => {
              setShowModalImage(false)
              handleReset()
            }}>
            <Modal.Body
              style={{
                padding: 0,
                position: 'relative',
                borderRadius: '10px',
                boxShadow: '0 5px 25px rgba(0,0,0,0.15)',
                border: '1px solid rgba(0,0,0,0.05)',
                overflow: 'hidden',
              }}>
              {/* Botón de cerrar */}
              <button
                onClick={() => {
                  setShowModalImage(false)
                  handleReset()
                }}
                style={{
                  position: 'absolute',
                  top: '20px',
                  right: '20px',
                  zIndex: 1000,
                  border: 'none',
                  backgroundColor: 'transparent',
                  cursor: 'pointer',
                  fontSize: '30px',
                  fontWeight: 'normal',
                  color: '#000',
                  padding: 0,
                  lineHeight: 1,
                }}
                data-testid="btn-close-product-image-modal">
                ✕
              </button>

              {/* Contenedor principal de la imagen */}
              <div
                className="container-image-modal"
                style={{
                  position: 'relative',
                  display: 'flex',
                  justifyContent: 'center',
                  alignItems: 'center',
                  minHeight: '70vh',
                  overflow: 'hidden',
                  backgroundColor: '#fff',
                  padding: '3rem',
                }}
                data-testid="container-product-modal-image">
                <img
                  className="img-modal"
                  src={showModalImage.image}
                  alt="Imagen"
                  style={{
                    transform: `scale(${zoom})`,
                    transition: 'transform 0.2s ease',
                    maxWidth: '90%',
                    maxHeight: '70vh',
                    width: 'auto',
                    height: 'auto',
                    objectFit: 'contain',
                  }}
                  data-testid="img-product-modal-image"
                />

                {/* Botones flotantes de zoom */}
                <div
                  className="zoom-controls"
                  style={{
                    position: 'absolute',
                    left: '30px',
                    bottom: '30px',
                    display: 'flex',
                    flexDirection: 'column',
                    gap: '10px',
                    zIndex: 10,
                  }}
                  data-testid="container-product-image-zoom-controls">
                  <button
                    onClick={handleZoomIn}
                    style={{
                      width: '40px',
                      height: '40px',
                      borderRadius: '50%',
                      border: 'none',
                      backgroundColor: '#fff',
                      boxShadow: '0 2px 6px rgba(0,0,0,0.3)',
                      cursor: 'pointer',
                      fontSize: '20px',
                      fontWeight: 'bold',
                    }}
                    data-testid="btn-zoom-in-product-image">
                    +
                  </button>
                  <button
                    onClick={handleZoomOut}
                    style={{
                      width: '40px',
                      height: '40px',
                      borderRadius: '50%',
                      border: 'none',
                      backgroundColor: '#fff',
                      boxShadow: '0 2px 6px rgba(0,0,0,0.3)',
                      cursor: 'pointer',
                      fontSize: '20px',
                      fontWeight: 'bold',
                    }}
                    data-testid="btn-zoom-out-product-image">
                    −
                  </button>
                </div>
              </div>
            </Modal.Body>
          </Modal>
        </div>
      )}
      <div>
        <Modal
          show={showAlertDontAddProduct}
          backdrop="static"
          className="modal-clase-price-change"
          centered>
          <GenericModal
            setIsOpen={() => setShowAlertDontAddProduct(false)}
            showCaution={true}
            hideCheck={true}
            text={t('GENERIC_MODAL.NO_INVENTORY_ALERT')}
            mostrarButtons={false}></GenericModal>
        </Modal>
      </div>
      <NetworkErrorAlert
        open={showNetworkErrorAlert}
        message={t('GENERIC_MODAL.NETWORK_ERROR_ADD_PRODUCT')}
        onClose={() => setShowNetworkErrorAlert(false)}
      />
      <NetworkErrorAlert
        open={apiErrorMessage !== null}
        message={
          t('GENERIC_MODAL.API_ERROR_ADD_PRODUCT') +
          (apiErrorMessage ? ': ' + apiErrorMessage : '.')
        }
        onClose={() => setApiErrorMessage(null)}
      />
    </>
  )
}

export default ProductDetail
